import { extend, setInteractionMode } from 'vee-validate';
import { required, email, is, max, min, max_value, min_value, numeric, regex, excluded } from 'vee-validate/dist/rules';
import {urlRegex} from "@/design-system/forms/validation/url-validator"


// todo: configure webpack not to bundle vee-validate
export function installJdsValidation() {
    extend('jdsv_email', email)
    extend('jdsv_numeric', numeric)
    extend('jdsv_required', required)
    extend('jdsv_is', is)
    extend('jdsv_max_length', max)
    extend('jdsv_min_length', min)
    extend('jdsv_max', max_value)
    extend('jdsv_min', min_value) // make this expose a scoped slot for `min` instead of `min_value`
    extend('jdsv_pattern', regex)
    extend('jdsv_deny', excluded)

    // custom stuff
    extend('jdsv_url', (value) => {
        try {
            if (!value) return true
            return urlRegex.test(value)
        } catch (e) {
            return true
        }
    })

    // maybe, export these rules and have consumers do the extend?

    setInteractionMode('eager');
}
